import TomSelect from "tom-select";

document.addEventListener("DOMContentLoaded", () => {
  const nameInput = document.querySelector("#free-roadmap-name-input");
  const emailInput = document.querySelector("#free-roadmap-email-input");
  const generateReportButton = document.querySelector("#generate-report-button");
  const generateGitHubReportButton = document.querySelector("#generate-github-report-button");
  const acceptPrivacyStatement = document.querySelector("#accept-privacy-statement");

  function checkInputs() {
    if (generateGitHubReportButton) {
      generateGitHubReportButton.disabled = !emailInput.value || !acceptPrivacyStatement.checked;
    }

    if (generateReportButton) {
      generateReportButton.disabled = !(nameInput.value && emailInput.value) || !acceptPrivacyStatement.checked;
    }
  }

  if (nameInput) {
    nameInput.addEventListener("input", checkInputs);
  }
  if (emailInput) {
    emailInput.addEventListener("input", checkInputs);
  }
  if (acceptPrivacyStatement) {
    acceptPrivacyStatement.addEventListener("change", checkInputs);
  }

  const repoInput = document.querySelector("#repo-select");
  if (repoInput) {
    // Initialize TomSelect
    new TomSelect(repoInput, {
      optgroupField: 'class',
      labelField: 'name',
      valueField: 'value',
      searchField: ['name'],
      placeholder: "Search GitHub Repositories...",
      load: function(query, callback) {
        fetch(`/free-roadmap/repos?q=${encodeURIComponent(query)}`)
          .then(response => response.json())
          .then(json => {
            const optGroups = Object.keys(json).map(key => ({ value: key, label: key }));
            const options = Object.keys(json).flatMap(key => {
              return json[key].map(item => ({ class: key, value: item["full_name"], name: item["name"] }))
            });
            callback(options, optGroups);
            self.settings.load = null;
          }).catch(()=>{
            callback();
          });
      },
    });
  }
});
